import _ from "lodash";
import React, { Component } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/customapps";
import AwardDisplay from "../components/common/AwardDisplay";
import Title from "../components/common/Title";
import { Mixpanel } from "../mixpanel";
import award from "../resources/icons/award.png";
import first from "../resources/icons/first_win.png";
import star from "../resources/icons/icon_star.png";
import club from "../resources/icons/millennial_club.png";
import mm from "../resources/icons/multi-month.png";
import paper from "../resources/icons/paper.png";
import ww from "../resources/icons/weekend_warrior.png";
import "../resources/styles/BigCalendar.css";
import colors from "../styles/colors";
import layout from "../styles/layout";
import AppFrame from "./AppFrame";

const style = {
  earnedBadgesLable: {
    color: colors.orange,
    fontSize: 20,
    fontWeight: 900,
  },
  badgesContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
};

const ptsTrophyArray = [
  1000, 2000, 3000, 4000, 5000, 10000, 25000, 50000, 100000, 150000, 200000,
  250000,
];

class PatientAwards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: props.match.params.userId,
      appId: props.match.params.appId,
      customApp: {},
      width: 0,
      height: 0,
      userActivities: [],
    };
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  componentWillMount() {
    this.props.fetchCustomApp(this.state.appId, this.state.userId);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.userId &&
      this.state.appId &&
      _.isEmpty(this.state.customApp) &&
      !_.isEmpty(nextProps.customapps.customApps[this.state.appId])
    ) {
      Mixpanel.track("Patient view award page", {
        "User ID": this.state.userId,
      });
      const customApps = nextProps.customapps.customApps[this.state.appId];
      this.setState({
        customApp: customApps[this.state.userId],
      });
      this.props.getUserActivityForCustomApp(
        this.state.userId,
        customApps[this.state.userId].customAppId
      );
    }

    if (nextProps.customapps.userActivity) {
      this.setState({ userActivities: nextProps.customapps.userActivity });
    }
  }

  renderNewGuyTrophyAwarded() {
    return this.state.userActivities.length
      ? this.state.userActivities.length <= 0
      : true;
  }

  renderAwardedPointsTrophy(pts) {
    return parseInt(this.state.customApp.points) < parseInt(pts);
  }

  renderTherapyStart() {
    return this.state.userActivities.length
      ? this.state.userActivities.length < 20
      : true;
  }

  progressTherapyStart() {
    return this.state.userActivities.length
      ? this.state.userActivities.length
      : 0;
  }

  weekendWarrior() {
    let onWeekend = 0;
    if (this.state.userActivities) {
      this.state.userActivities.map((a) => {
        const dt = new Date(
          a.activityDate.year,
          a.activityDate.month - 1,
          a.activityDate.day + 1
        );

        if (dt.getDay() === 0 || dt.getDay() === 6) {
          onWeekend = onWeekend + 1;
        }
      });
    }
    return onWeekend;
  }

  renderWeekendWarrior() {
    return !(this.weekendWarrior() > 3);
  }

  progressWeekendWarrior() {
    return this.weekendWarrior();
  }

  evaluateMultiMonth() {
    let months = [];
    if (this.state.userActivities) {
      let sortedDates = this.state.userActivities.map((a) => {
        if (months.indexOf(a.activityDate.month) === -1) {
          months.push(a.activityDate.month);
        }
      });
    }
    return months.length;
  }

  progressMultiMonth() {
    return this.evaluateMultiMonth() > 1 ? 2 : this.evaluateMultiMonth();
  }

  renderMultiMonth() {
    return !(this.evaluateMultiMonth() > 1);
  }

  renderOneKClub() {
    return !(
      (this.state.userActivities ? this.state.userActivities.length : 0) > 1000
    );
  }

  progressOneKClub() {
    return this.state.userActivities ? this.state.userActivities.length : 0;
  }

  evaluateDailyReports() {
    let numInARow = 0;
    let lastFound = null;
    let criteriaMet = false;
    let maxNumInRow = 1;

    let sortedDates = this.state.userActivities.sort(
      (a, b) =>
        new Date(
          a.activityDate.year,
          a.activityDate.month,
          a.activityDate.day
        ) -
        new Date(b.activityDate.year, b.activityDate.month, b.activityDate.day)
    );

    sortedDates.map((activity) => {
      if (
        (lastFound && lastFound.getTime()) ===
        new Date(
          activity.activityDate.year,
          activity.activityDate.month,
          activity.activityDate.day
        ).getTime()
      ) {
        //do nothing
      } else if (
        (lastFound && this.addDays(lastFound, 1).getTime()) ===
        new Date(
          activity.activityDate.year,
          activity.activityDate.month,
          activity.activityDate.day
        ).getTime()
      ) {
        numInARow = numInARow + 1;
      } else {
        numInARow = 1;
      }

      lastFound = new Date(
        activity.activityDate.year,
        activity.activityDate.month,
        activity.activityDate.day
      );
      if (maxNumInRow < numInARow) {
        maxNumInRow = numInARow;
      }
    });
    return numInARow;
  }

  renderDailyReporter() {
    let numInARow = 0;
    let lastFound = null;
    let criteriaMet = false;
    let maxNumInRow = 1;
    if (this.state.userActivities) {
      numInARow = this.evaluateDailyReports();

      if (numInARow >= 7) {
        criteriaMet = true;
      }
      return !criteriaMet;
    } else {
      return true;
    }
  }

  progressDailyReporter() {
    let numInARow = 0;
    if (this.state.userActivities) {
      numInARow = this.evaluateDailyReports();
      return numInARow;
    } else {
      return 0;
    }
  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  mixpanelAwardDetail() {
    Mixpanel.track("Patient award detail viewd", {
      "User ID": this.state.userId,
    });
  }

  pointTrophyLeveIsClose(pts, index) {
    let diff = parseInt(pts) - parseInt(this.state.customApp.points);
    if (!index) {
      return diff > 0 && diff < parseInt(pts);
    } else {
      return diff > 0 && diff < parseInt(pts) - ptsTrophyArray[index - 1];
    }
  }

  renderEventAchievementBadges() {
    return (
      <div style={style.badgesContainer}>
        <AwardDisplay
          onClick={() => this.mixpanelAwardDetail()}
          title="Committed To Success"
          img={first}
          disabled={this.renderNewGuyTrophyAwarded()}
          progress={this.renderNewGuyTrophyAwarded() ? 0 : 1}
          progressType={" of 1 Logged Activities"}
          progressMax={1}
          info="'Committed To Success!' badge is given out for completing your first activity. Use the 'Daily Points' feature to track your activity."
        />
        <AwardDisplay
          title="Daily Reporter"
          img={paper}
          disabled={this.renderDailyReporter()}
          progress={
            this.renderDailyReporter() ? this.progressDailyReporter() : null
          }
          progressType={" of 7 days straight"}
          progressMax={7}
          info="'The Daily Reporter' badge is given out for completing your instructions every day for 7 days straight."
        />
        <AwardDisplay
          title="Weekend Warrior"
          img={ww}
          onClick={() => this.mixpanelAwardDetail()}
          disabled={this.renderWeekendWarrior()}
          progress={
            this.renderWeekendWarrior() ? this.progressWeekendWarrior() : null
          }
          progressType={" of 4 weekend exercises"}
          progressMax={4}
          info="'The Weekend Warrior' badge is given out for completing 4 days of weekend instructions."
        />
        <AwardDisplay
          title="Multi-Month"
          img={mm}
          onClick={() => this.mixpanelAwardDetail()}
          disabled={this.renderMultiMonth()}
          progress={this.progressMultiMonth()}
          progressType={" of 2 months with activities"}
          progressMax={2}
          info="'Multi-Month' badge is given out for completing activities in multiple months."
        />
        <AwardDisplay
          title="Shining Star"
          img={star}
          disabled={this.renderTherapyStart()}
          progress={this.progressTherapyStart()}
          progressType={" of 20 days of activity"}
          progressMax={20}
          info="'The Therapy Star' badge is given out for completing 20 days of activity."
        />
        <AwardDisplay
          title="1K Club"
          img={club}
          onClick={() => this.mixpanelAwardDetail()}
          disabled={this.renderOneKClub()}
          progress={this.progressOneKClub()}
          progressType={" of 1000 activities logged"}
          progressMax={1000}
          info="'1K Club' badge is given out for completing 1,000 activities."
        />
      </div>
    );
  }

  renderPointsAchievementBadges() {
    return (
      <div style={style.badgesContainer}>
        {ptsTrophyArray.map((i, index) => {
          return (
            <AwardDisplay
              title={`+${i} pts`}
              img={award}
              onClick={() => this.mixpanelAwardDetail()}
              disabled={this.renderAwardedPointsTrophy(i)}
              progress={
                this.pointTrophyLeveIsClose(i, index)
                  ? parseInt(this.state.customApp.points)
                  : null
              }
              progressType={
                this.pointTrophyLeveIsClose(i, index)
                  ? " of " + i + " pts"
                  : null
              }
              progressMax={i}
              info={`\'+${i} pts\' badge is given out for collecting ${i} pts.`}
            />
          );
        })}
      </div>
    );
  }

  render() {
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }
    return (
      <AppFrame auth={this.props.auth} targetDevice={targetDevice}>
        <div style={layout.common.page}>
          <Title text2={"Awards"} goBack={() => this.props.history.goBack()} />
          <div style={layout.common.mainContainer}>
            <p style={layout.common.subHeading}> Earned Badges</p>
            <br />

            <p style={layout.common.label}>Event Achievement Badges</p>
            {this.renderEventAchievementBadges()}

            <p style={layout.common.label}>Points Achievement Badges</p>
            {this.renderPointsAchievementBadges()}
          </div>
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, customapps }) {
  return {
    user,
    customapps,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientAwards);



// WEBPACK FOOTER //
// ./src/layout/PatientAwards.js